<template>
  <div
    class="avatar-container"
    :class="{
      some: !!image,
      none: !image,
      clickable: !!clickable,
      small: size === 'small',
      medium: size === 'medium',
      large: size === 'large'
    }"
  >
    <span v-if="!!image">
      <img :src="image" v-if="!!image" :class="size" />
    </span>
    <span v-else :uk-icon="'icon: user; ratio: ' + ratio"> </span>
  </div>
</template>
<style lang="scss" scoped>
.avatar-container.none {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid $border-color_primary;
  background-color: #fff;
}
.avatar-container.some {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  img {
    border-radius: 50%;
    border: 1px solid $border-color_primary;
    background-color: #fff;
  }
}
.small {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
}
.medium {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
}
.large {
  width: 56px;
  height: 56px;
  min-width: 56px;
  min-height: 56px;
}
.clickable {
  cursor: pointer;
}
</style>
<script lang="ts">
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export enum Size {
  S = "small",
  M = "medium",
  L = "large"
}
const SizeToRatio = {
  [Size.S]: 1,
  [Size.M]: 1.2,
  [Size.L]: 1.5
};
export default class Avatar extends Vue {
  @Prop({ type: String }) image = "";
  @Prop({ type: String, default: "medium" }) size: Size = Size.M;
  @Prop({ type: Boolean, default: true }) clickable = true;
  get ratio() {
    return SizeToRatio[this.size];
  }
}
</script>
